// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14lIy","toggle":"styles_toggle__2yA0s","preview":"styles_preview__MOSgZ"};